import { useEffect, useState } from "react";
import { Button, Dialog, styled, Tooltip, Typography } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from "moment";

const DialogContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '16px',
});

export default function ConfirmLongTaskDialog(props) {
    const [startTime, setStartTime] = useState(moment());

    const handleClick = (time) => {
        props.handleValidateTask(props.task, time);
    };

    const handleEdit = (value) => {
        setStartTime(moment().set({"hour": value.hours(), "minute": value.minutes()}))
    };

    useEffect(() => {
        if (props.open) {
            setStartTime(moment());
        }
    }, [props.open]);

    return (
        <Dialog open={props.open} maxWidth="xs" margin="auto">
            <DialogContent>
                <Typography variant="h5" align="center" gutterBottom>
                    This task seems too long!
                </Typography>
                <div style={{ margin: '20px 0' }}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <TimePicker
                            label="New time for today"
                            value={startTime}
                            onChange={handleEdit}
                            disableFuture
                        />
                    </LocalizationProvider>
                </div>
                <Tooltip title="Keep the original start time">
                    <Button variant="contained" color="primary" onClick={() => handleClick()} style={{ marginBottom: 10 }}>
                        Don't change
                    </Button>
                </Tooltip>
                <Tooltip title="Fix for today">
                    <Button variant="contained" color="primary" onClick={() => handleClick(startTime.toDate())}>
                        Fix time
                    </Button>
                </Tooltip>
            </DialogContent>
        </Dialog>
    );
}